// 运输码
import httpRequest from '@/utils/request.js'

/**
 * 获取运输吗
 * @param carrierId
 * @param carrierType
 * @returns {Promise | Promise<unknown>}
 */
export const getTransportCode = (carrierId, carrierType) =>
  httpRequest.httpGet({
    url: `/service/carrier/transportation/qrcode/${carrierType}`,
    params: {
      carrierId
    }
  })

/**
 * 获取运输记录
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const getTransRecord = (params) => httpRequest.httpGet({
  url: '/service/trans/lst',
  params
})

export const getTransReach = (transId) => httpRequest.httpGet({
  url: '/service/trans/reach/lst',
  params: {
    transId
  }
})

export const getTransHistory = (transId) => httpRequest.httpGet({
  url: '/service/trans/track',
  params: {
    transId
  }
})
